import { Button, Space } from '@vivaldis/antd-ui'
import { Show } from '@vivaldis/icons'
import { useTranslation } from 'react-i18next'
import { EmployeeDetailsQuery_employee_teamCompanies } from '../../../../../graphql/__generated__/EmployeeDetailsQuery'

interface Props {
  teamCompany: EmployeeDetailsQuery_employee_teamCompanies
}

export const Actions = ({ teamCompany }: Props) => {
  const [t] = useTranslation()

  return (
    <Space size="large">
      <Button
        to={`/companies/${teamCompany.id}`}
        type="link"
        size="middle"
        style={{ paddingLeft: 0, paddingRight: 0 }}
        icon={<Show />}
      >
        {t(
          'screens.employee_details.tabs.companies.table.columns.actions.view_company'
        )}
      </Button>
    </Space>
  )
}
